(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ta-cart"] && !Shopify.designMode) return;
  try {
    
  /* Modifie une quantite sans quitter la page. Le rechargement qui suit laisse
     le serveur recalculer les remises et les totaux : c'est plus sur que de les
     recalculer ici, ou l'on finirait par afficher un montant different de celui
     qui sera facture. */
  class TaPanier extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const bouton = e.target.closest('[data-plus], [data-moins], [data-retirer]');
        if (!bouton) return;

        const ligne = bouton.closest('[data-ligne]');
        if (!ligne || ligne.dataset.occupe) return;

        const actuelle = parseInt(ligne.querySelector('[data-qte]').textContent.trim(), 10) || 1;
        let voulue = actuelle;
        if (bouton.hasAttribute('data-plus')) voulue = actuelle + 1;
        else if (bouton.hasAttribute('data-moins')) voulue = actuelle - 1;
        else voulue = 0;
        if (voulue < 0) voulue = 0;

        ligne.dataset.occupe = '1';
        ligne.style.opacity = '.45';

        fetch(this.dataset.urlPanier + '/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: ligne.dataset.cle, quantity: voulue }),
        })
          .then((r) => {
            if (!r.ok) throw new Error('panier ' + r.status);
            window.location.reload();
          })
          .catch(() => {
            /* on rend la main plutot que de laisser une ligne grisee et figee */
            delete ligne.dataset.occupe;
            ligne.style.opacity = '';
          });
      });
    }
  }
  if (!customElements.get('ta-panier')) customElements.define('ta-panier', TaPanier);

  } catch(e) { console.error(e); }
})();
})();
